const capabilities = [
  {
    num: '01',
    title: 'Intelligence',
    sub: 'Research · Data · Public Opinion',
    icon: 'ri-search-eye-line',
    items: [
      'Socio-economic research',
      'Public opinion surveys',
      'Constituency intelligence',
      'Field research',
      'Data analytics',
    ],
    accent: 'accent',
  },
  {
    num: '02',
    title: 'Strategy',
    sub: 'Insight · Planning · Advisory',
    icon: 'ri-compass-3-line',
    items: [
      'Strategic advisory',
      'Campaign strategy',
      'Communication planning',
      'Stakeholder engagement',
      'Public perception analysis',
    ],
    accent: 'primary',
  },
  {
    num: '03',
    title: 'Communication',
    sub: 'Narrative · Digital · Outreach',
    icon: 'ri-chat-voice-line',
    items: [
      'Digital communication',
      'IEC campaigns',
      'Social media',
      'Public awareness',
      'Creative communication',
    ],
    accent: 'accent',
  },
  {
    num: '04',
    title: 'Innovation',
    sub: 'Technology · Platforms · Systems',
    icon: 'ri-node-tree',
    items: [
      'Technology platforms',
      'Dashboards & MIS',
      'Data systems',
      'Digital applications',
      'Analytics solutions',
    ],
    accent: 'primary',
  },
];

export default function Capabilities() {
  return (
    <section id="capabilities" className="relative w-full bg-background-100/60 py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 bg-dots-soft opacity-40 mask-radial-fade pointer-events-none"></div>

      <div className="relative px-6 md:px-16 lg:px-28">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 md:mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="text-[10px] tracking-[0.3em] uppercase text-foreground-500 font-mono">02 / Capabilities</span>
            </div>
            <h2 data-reveal className="text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.08] text-foreground-950 tracking-tight font-semibold max-w-xl">
              Four capabilities. One purpose.
            </h2>
          </div>
          <p data-reveal="fade" className="max-w-sm text-[15px] leading-[1.8] text-foreground-600">
            These four pillars are the defined scope of the Prabhaw venture — built
            to move complex public work from intent to outcome.
          </p>
        </div>

        {/* Cards */}
        <div data-reveal-stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {capabilities.map((c) => (
            <article
              key={c.title}
              className={`stagger-child group relative rounded-2xl border border-background-200 p-7 md:p-8 flex flex-col overflow-hidden transition-colors duration-300 ${
                c.accent === 'primary'
                  ? 'bg-primary-800 text-white hover:bg-primary-900'
                  : 'bg-background-50 text-foreground-950 hover:bg-accent-50'
              }`}
            >
              <div
                className={`absolute -right-8 -top-8 w-28 h-28 rounded-full blur-2xl pointer-events-none ${
                  c.accent === 'primary' ? 'bg-accent-500/20' : 'bg-primary-200/50'
                }`}
              ></div>
              <div className="relative flex items-center justify-between mb-8">
                <span
                  className={`w-12 h-12 rounded-lg flex items-center justify-center ${
                    c.accent === 'primary' ? 'bg-white/10 text-accent-400' : 'bg-primary-100 text-primary-700'
                  }`}
                >
                  <i className={`${c.icon} w-6 h-6 flex items-center justify-center`}></i>
                </span>
                <span className={`text-3xl font-light ${c.accent === 'primary' ? 'text-white/30' : 'text-foreground-200'}`} style={{ fontFamily: 'var(--font-heading)' }}>
                  {c.num}
                </span>
              </div>
              <div className="relative">
                <h3 className={`text-2xl tracking-wide font-semibold ${c.accent === 'primary' ? 'text-accent-400' : 'text-primary-800'}`}>
                  {c.title}
                </h3>
                <p className={`mt-1 text-[11px] tracking-[0.18em] uppercase font-mono ${c.accent === 'primary' ? 'text-white/70' : 'text-foreground-500'}`}>
                  {c.sub}
                </p>
                <ul className="mt-6 flex flex-col gap-2.5">
                  {c.items.map((it) => (
                    <li key={it} className={`flex items-center gap-2.5 text-[13px] leading-snug ${c.accent === 'primary' ? 'text-white/85' : 'text-foreground-600'}`}>
                      <i className={`ri-check-line w-4 h-4 flex items-center justify-center shrink-0 ${c.accent === 'primary' ? 'text-accent-400' : 'text-primary-600'}`}></i>
                      {it}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}